import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import GetIcon from "../../../../utils/Icon";
import VersionHistory from "../../../../utils/VersionHistory";

function Tab1({ fulldata,activityboll }) {
  const [showActivity, setShowActivity] = useState(true);

    return (
        <div
            className="row sidebarbox m-0"
            style={{ padding: "8px", borderRadius: "5px", height: '70vh', overflowY: 'scroll', fontSize: '12px' }}
        >
            <div style={{ height: '28vh' }}>
                <div className="d-flex" style={{ marginBottom: '6px', gap: 'px' }}>
                    <div className="col-md-6 " >
                        <div className=" position-relative floating-date-wrapper px-1">

                            <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="No." readOnly value={fulldata?.name} />

                        </div>
                    </div>
                    <div className="col-md-6 " >
                        <div className=" position-relative floating-date-wrapper">
                            <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="Date" readOnly value={fulldata?.creation.split(" ")[0]} />

                        </div>
                    </div>


                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="position-relative floating-select-wrapper">

                        <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="Purpose" readOnly value={fulldata?.purpose} />

                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="position-relative floating-select-wrapper">

                        <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="Work Order" readOnly value={fulldata?.work_order} />

                    </div>
                </div>

                <div className="col-12" style={{ marginBottom: '12px' }}>
                    <div className="mb-3 position-relative floating-date-wrapper">

                        <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="Time" readOnly value={fulldata?.time.split(".")[0]} />

                    </div>
                </div>


                
      <div className="col-12">
          <div className="py-2 d-flex justify-content-between align-items-center" onClick={() => setShowActivity(!showActivity)}>
            <p className="firstcolor m-0" style={{fontSize:'0.8rem'}}>
              Activity
            </p>
            <GetIcon
              iconName={showActivity ? "MdKeyboardArrowUp" : "MdKeyboardArrowDown"}
              size={22}
            />
          </div>
          {showActivity && (
            <VersionHistory doctype="Purchase Receipt" docname={fulldata?.name} activityboll={activityboll} />

          )}
        </div>


            </div>


        </div>
    );
}

export default Tab1;
